import { IonIntlTelInputModule } from '@app/shared/compat/ion-intl-tel-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SignupPage } from './signup.page';
import { SharedDirectiveModule } from '@app/shared/directives/shared-directive.module';
import { VerifyOTPPageModule } from '../verify-OTP/verify-otp/verify-otp.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    IonIntlTelInputModule,
    SharedDirectiveModule,
    VerifyOTPPageModule
  ],
  declarations: [SignupPage]
})
export class SignupPageModule { }
